var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoCoachesPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.715,
    height: 15.001,
    viewBox: "0 0 15.715 15.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8146",
    "data-name": "Rectangle 8146",
    width: 15.715,
    height: 15.001,
    fill: "#7e7e7e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15544",
    "data-name": "Group 15544",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15542",
    "data-name": "Group 15542",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5367",
    "data-name": "Path 5367",
    d: "M16.857,18.662H9.786a.786.786,0,0,1,0-1.571h7.072a.786.786,0,0,1,0,1.571",
    transform: "translate(-1.928 -3.662)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5368",
    "data-name": "Path 5368",
    d: "M.786,15a.786.786,0,0,1-.762-.977l.786-3.143a.791.791,0,0,1,.207-.365L10.838.7a2.51,2.51,0,0,1,3.468,0,2.455,2.455,0,0,1,0,3.468L4.484,13.986a.794.794,0,0,1-.365.206l-3.143.786A.758.758,0,0,1,.786,15m1.5-3.527-.415,1.661,1.661-.416L13.2,3.053a.884.884,0,0,0,0-1.246.9.9,0,0,0-1.246,0ZM11.393,1.251h0Z",
    transform: "translate(0 0)",
    fill: "#7e7e7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoCoachesPenIcon);
export default __webpack_public_path__ + "static/media/co-coaches-pen-icon.e272604ad84bde3d1b106b78c4426ac8.svg";
export { ForwardRef as ReactComponent };